module.exports = __webpack_public_path__ + "static/img/19.54970a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/eng/19.png
// module id = 3Hqp
// module chunks = 0